import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../common/BrandLogo";

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="app-container">
      <header className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="brand">
            <BrandLogo size={32} />
          </Link>
          <Link to="/" className="btn btn-secondary">
            Volver al inicio
          </Link>
        </div>
      </header>

      <main className="page-section">
        <div className="section-content" style={{ maxWidth: "500px" }}>
          <article className="panel" style={{ gap: "1.5rem" }}>
            <div>
              <h1 className="section-title" style={{ fontSize: "2rem", marginBottom: "0.75rem" }}>
                {title}
              </h1>
              <p className="section-subtitle" style={{ marginTop: 0 }}>
                {subtitle}
              </p>
            </div>
            {children}
          </article>
          {footer && <div style={{ marginTop: "1.5rem" }}>{footer}</div>}
        </div>
      </main>
    </div>
  );
}
